import React from 'react';
import { TableCell } from '@mui/material';
import { ArcTableCellProps } from './types';

const ArcTableCell: React.FC<ArcTableCellProps> = (props) => {
  return <TableCell {...props} />;
};

export default ArcTableCell;